class LoadMoreProducts extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    const nextUrl = this.getAttribute('data-next-url');
    if (!nextUrl || this.button.getAttribute('aria-disabled') === 'true') return;

    this.button.setAttribute('aria-disabled', 'true');
    this.button.classList.add('loading');

    fetch(nextUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const grid = document.getElementById('product-grid');
        const newItems = html.querySelectorAll('#product-grid > li');
        newItems.forEach((item) => grid.appendChild(item));

        const newPagination = html.querySelector('.pagination-wrapper');
        const currentPagination = document.querySelector('.pagination-wrapper');
        if (newPagination && currentPagination) {
          currentPagination.replaceWith(newPagination);
        } else if (currentPagination) {
          currentPagination.remove();
        }

        const newViewedCount = html.querySelector('[data-viewed-count]');
        const currentViewedCount = document.querySelector('[data-viewed-count]');
        if (newViewedCount && currentViewedCount) {
          currentViewedCount.innerHTML = newViewedCount.innerHTML;
        }

        const newLoadMore = html.querySelector('load-more-products');
        if (newLoadMore) {
          this.setAttribute('data-next-url', newLoadMore.getAttribute('data-next-url'));
          this.button.removeAttribute('aria-disabled');
          this.button.classList.remove('loading');
        } else {
          this.remove();
        }

        if (window.history.replaceState) {
          window.history.pushState({}, '', nextUrl);
        }
      })
      .catch((e) => {
        console.error(e);
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
      });
  }
}

customElements.define('load-more-products', LoadMoreProducts);
